"use client";

import { useStores } from "../../../stores/useStores";
import { IWidgetTypes, Widget } from "./Widget";
import {
  IFallbackData,
  ISchoolFeedUrlQueries,
} from "../../../utils/SchoolBlocksUtilities";
import { observer } from "mobx-react";
import {
  ContactCardOrganization,
  LeaderboardEntry,
} from "../SchoolFeedDisplay";

const MOBILE_WIDGETS = [
  IWidgetTypes.CONTRIBUTING_ORGANIZATIONS,
  IWidgetTypes.SHOP,
  IWidgetTypes.CONTACT,
  IWidgetTypes.LEADERBOARD,
];

export const WidgetRenderer = observer(
  (props: {
    urlQuery: ISchoolFeedUrlQueries;
    context?: "mobile" | undefined;
    widgetPromises: {
      leaderboard: Promise<LeaderboardEntry[]>;
      contactCard: Promise<ContactCardOrganization>;
      contributingOrgs: Promise<number>;
      events: Promise<IFallbackData>;
    };
  }) => {
    const { organizationStore } = useStores();

    return (
      <div>
        {organizationStore.currentOrganization.widgets
          .filter((widget) => {
            if (props.context === "mobile") {
              return MOBILE_WIDGETS.includes(widget.type);
            }
            return true;
          })
          .map((widget) => {
            const widgetProps: any = {
              widget,
              urlQuery: props.urlQuery,
            };
            switch (widget.type) {
              case IWidgetTypes.LEADERBOARD:
                widgetProps.leaderboardDataPromise =
                  props.widgetPromises.leaderboard;
                break;
              case IWidgetTypes.CONTACT:
                widgetProps.contactCardDataPromise =
                  props.widgetPromises.contactCard;
                break;
              case IWidgetTypes.CONTRIBUTING_ORGANIZATIONS:
                widgetProps.contributingOrganizationsCountPromise =
                  props.widgetPromises.contributingOrgs;
                break;
              case IWidgetTypes.EVENTS:
                widgetProps.initialEventsPromise = props.widgetPromises.events;
                break;
            }
            return <Widget key={widget.type} {...widgetProps} />;
          })}
      </div>
    );
  },
);
